module.exports = __webpack_public_path__ + "static/media/web_service_img_2.05c26ad1.jpg";